/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Pos_To_DecideInputs */

const en_queue_pos_to_decide = /** @type {(inputs: Queue_Pos_To_DecideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supplier proposals to decide`)
};

/**
* | output |
* | --- |
* | "Supplier proposals to decide" |
*
* @param {Queue_Pos_To_DecideInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_pos_to_decide = /** @type {((inputs?: Queue_Pos_To_DecideInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Pos_To_DecideInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_pos_to_decide(inputs)
});